<style>
.is-invalid  .v-select  .vs__dropdown-toggle{
      border-color: #f46a6a;
}
</style>
<script>
import {
  required,
} from "vuelidate/lib/validators";
import { notify } from '@/helpers/notify' 

export default {
  name: 'CreateModal',
  props:[
    "list"
  ],
  data() {
    return {
      form: {},
      userList:[],
      submitted: false,
    };
  },
  validations: {
    form: {
      brand: { required },
      model: { required },
      year: { required },
      plaka: { required },
      user_id: { required },
    },
  },
  watch:{
    list(props){
      this.form = {...props}
    }
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
      this.$v.$touch();
     if (this.$v.$invalid) {
        return;
      } else {
        if(this.form.id)
          this.update();
        else
          this.create();
      }
      this.submitted = false;
    },
    create(){
     
      this.$http.post('/vehicles/store', { ...this.form })
        .then(resp => {
          if(!resp.data.error) this.form = {};

          this.$emit('loadItems');
          return notify.success(resp.data.message)
        })
        .catch(error => error)
    },
    update(){
      this.$http.put('/vehicles/' + this.form.id , this.form)
        .then(resp => {
          this.form = {};

          this.$emit('loadItems');
          return notify.success(resp.data.message)
        })
        .catch(error => error)
    },
    remove(id){
      this.$http.delete('/vehicles/' + id)
        .then(resp => {
          if(resp.data.code !==  100)  return notify.error(resp.data.message)

           this.$emit('loadItems');
           return notify.success(resp.data.message)
         })
        .catch(error => error)
    },
    close(){
      this.$parent.$bvModal.hide('modal-scoped')
    },
    userSearch(search) {
      this.$http.post('/users', { search })
        .then(resp => {
          this.userList = resp.data.data
        })
        .catch(error => error)
    },
  },
};
</script>

<template>
  <b-modal 
        id="modal-scoped"
        title="Araç Ekle"  
        no-close-on-backdrop 
        hide-footer>
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-6">
            <div class="mb-3">
              <label>Marka</label>
              <input
                v-model="form.brand"
                type="text"
                class="form-control"
                placeholder="Marka"
                :class="{
                    'is-invalid': submitted && $v.form.brand.$error,
                }"
                />
              <div
                v-if="submitted && !$v.form.brand.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-3">
              <label for="model">Model</label>
              <input
              id="model"
              v-model="form.model"
              type="text"
              class="form-control"
              placeholder="Model"
              :class="{
                  'is-invalid': submitted && $v.form.model.$error,
              }"
              />
              <div
              v-if="submitted && $v.form.model.$error"
              class="invalid-feedback"
              >
              <span v-if="!$v.form.model.required"
                  >Bu alanı doldurmak zorunludur.</span
              >
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <div class="mb-3">
              <label for="year">Yıl</label>
              <input
              id="year"
              v-model="form.year"
              type="text"
              class="form-control"
              placeholder="Yıl"
              :class="{
                  'is-invalid': submitted && $v.form.year.$error,
              }"
              />
              <div
              v-if="submitted && $v.form.year.$error"
              class="invalid-feedback"
              >
              <span v-if="!$v.form.year.required"
                  >Bu alanı doldurmak zorunludur.</span
              >
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="mb-3">
              <label for="plaka">Plaka</label>
              <input
              id="plaka"
              v-model="form.plaka"
              type="text"
              class="form-control"
              placeholder="Plaka"
              :class="{
                  'is-invalid': submitted && $v.form.plaka.$error,
              }"
              />
              <div
              v-if="submitted && $v.form.plaka.$error"
              class="invalid-feedback"
              >
              <span v-if="!$v.form.plaka.required"
                  >Bu alanı doldurmak zorunludur.</span
              >
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="mb-3">
              <label for="kilometer">KM</label>
              <input
              id="kilometer"
              v-model="form.kilometer"
              type="text"
              class="form-control"
              placeholder="KM" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <div class="mb-3">
              <label for="insurance_expiration">Sigorta Son Tarih</label>
              <input
                id="insurance_expiration"
                v-model="form.insurance_expiration"
                type="date"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-4">
            <div class="mb-3">
              <label for="kasko_expiration">Kasko Son Tarih</label>
              <input
                id="kasko_expiration"
                v-model="form.kasko_expiration"
                type="date"
                class="form-control"
              />
            </div>
          </div>
          <div class="col-4">
            <div class="mb-3">
              <label for="exam_expiration">Muayene Son Tarih</label>
              <input
                id="exam_expiration"
                v-model="form.exam_expiration"
                type="date"
                class="form-control"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="mb-3">
              <label for="user_id">Zimmet Edilen Kişi</label>
                <v-select 
                      v-model="form.user_id"
                      @search="userSearch" 
                      :filterable="false"
                      :options="userList"
                      label="name"
                      :reduce="r => r.id"
                      >
                    <template slot="no-options">
                      Kullanıcılarda Arayın
                    </template>
                <span slot="no-options">Sonuç Bulunamadı</span>
</v-select>
              <div
              v-if="submitted && $v.form.user_id.$error"
              class="invalid-feedback"
              >
              <span v-if="!$v.form.user_id.required"
                  >Bu alanı doldurmak zorunludur.</span
              >
              </div>
            </div>
          </div>
        </div>
    
        <div class="d-flex justify-content-between mt-3">
        <div>
          <b-button variant="danger"  v-if="form.id" @click="remove(form.id)">Sil</b-button>
        </div>
        <div>
          <b-button variant="light" @click="close()">Vazgeç</b-button>
          <b-button 
            v-if="form.id"
            type="submit" 
            variant="warning" 
            class="ms-1"
            >Güncelle
          </b-button>
          <b-button 
            v-else
            type="submit" 
            variant="success" 
            class="ms-1"
            >Oluştur
          </b-button>
        </div>
        </div>
      </form>
    </b-modal>
</template>